import { ClientIds } from "../../constants/utils/clientIds";

const getUrlByClientId = (clientId: string): string => {
	switch (clientId) {
		case ClientIds.WORLDSUPERLEAGUE: {
			return "https://worldsuperleague.noku.io";
		}
		case ClientIds.WORLDSUPERLEAGUE_BETA: {
			return "https://beta-worldsuperleague.noku.io";
		}
		case ClientIds.WORLDSUPERLEAGUE_LOCALHOST: {
			return "http://localhost:3020";
		}

		case ClientIds.CRYPTOHEROES: {
			return "https://cryptoheroes.noku.io";
		}
		case ClientIds.CRYPTOHEROES_BETA: {
			return "https://beta-cryptoheroes.noku.io";
		}
		case ClientIds.CRYPTOHEROES_LOCALHOST: {
			return "http://localhost:3010";
		}

		case ClientIds.MARKETPLACE: {
			return "https://marketplace.noku.io";
		}
		case ClientIds.MARKETPLACE_BETA: {
			return "https://beta-marketplace.noku.io";
		}
		case ClientIds.MARKETPLACE_LOCALHOST: {
			return "http://localhost:3090";
		}

		case ClientIds.WALLET: {
			return "https://wallet.noku.io";
		}
		case ClientIds.WALLET_ROPSTEN: {
			return "https://ropsten.wallet.noku.io";
		}
		case ClientIds.WALLET_LOCALHOST: {
			return "http://localhost:3006";
		}

		case ClientIds.ACCOUNTS: {
			return "https://accounts.noku.io";
		}
		case ClientIds.ACCOUNTS_ROPSTEN: {
			return "https://ropsten.accounts.noku.io";
		}
		case ClientIds.ACCOUNTS_LOCALHOST: {
			return "http://localhost:3002";
		}

		default: {
			throw new Error(`Unknown client id: ${clientId}`);
		}
	}
};

export default getUrlByClientId;
